import React, { useState } from "react";
import SEO from "./seo";
import Header from "./header";
import Footer from "./footer";
import BreadCrumb from "./breadcrumb";
import { Context, ComposableContext } from "../context";
const Layout = ({ children, infos, seo }) => {
    const [isMenuVisible, toggleMenu] = useState(false);
    const context = React.useContext(Context);
    const customBreadcrumbs = context.settings.metadata.customBreadcrumbs;
    return (React.createElement(React.Fragment, null,
        React.createElement(SEO, { infos: infos, seo: seo, menuState: isMenuVisible }),
        React.createElement(Header, { menuStateUpdate: (bool) => toggleMenu(bool) }),
        customBreadcrumbs && children ? React.createElement(React.Fragment, null) : React.createElement(BreadCrumb, { infos: infos }),
        React.createElement("main", { id: "main", "data-title": infos?.title, "data-rnd": parseInt(Math.random() * 4) }, customBreadcrumbs && children
            ? React.cloneElement(children, {
                ...children.props,
                breadcrumbs: React.createElement(BreadCrumb, { infos: infos }),
            })
            : children),
        React.createElement(Footer, null)));
};
const ContextLayout = ({ data, children, infos, seo }) => {
    const dataCopy = { ...data };
    //~ const currentContent = (dataCopy.wpPage || dataCopy.wpTemplate || dataCopy.wpPost || dataCopy.sitemap);
    return (React.createElement(ComposableContext, { allPdf: dataCopy.siteMeta.siteMetadata.hasPDFreader
            ? dataCopy.allPdf
            : undefined, allMaps: dataCopy.siteMeta.siteMetadata.hasMap ? dataCopy.allWpGcomap : undefined, allImages: [
            ...(dataCopy.wpPage?.mediaContent?.nodes || []),
            ...(dataCopy.wpPost?.mediaContent?.nodes || []),
            ...(dataCopy.wpTemplate?.mediaContent?.nodes || []),
            ...(dataCopy.sitemap?.mediaContent?.nodes || []),
        ], subQueries: [
            ...(dataCopy.wpPage?.subQueries?.nodes || []),
            ...(dataCopy.wpPost?.subQueries?.nodes || []),
            ...(dataCopy.wpTemplate?.subQueries?.nodes || []),
            ...(dataCopy.sitemap?.subQueries?.nodes || []),
        ], featuredImage: dataCopy.wpPost?.featuredImage, settings: {
            metadata: dataCopy.siteMeta.siteMetadata,
            manifestOptions: dataCopy.manifestPlugin.pluginOptions,
            parserImages: dataCopy.parserImages,
            general: {
                ...dataCopy.settingsWp.themeGeneralSettings,
                ...dataCopy.settingsWp.generalSettings,
                dateFormat: dataCopy.settingsWp.allSettings.generalSettingsDateFormat,
            },
        }, menus: {
            secondary: dataCopy.secondaryMenu,
            main: dataCopy.mainMenu,
            footer: dataCopy.footerMenu,
        }, wc: dataCopy.siteMeta.siteMetadata.hasWc
            ? {
                allProducts: [
                    ...(dataCopy.wpPage?.products?.nodes || []),
                    ...(dataCopy.wpPost?.products?.nodes || []),
                    ...(dataCopy.wpTemplate?.products?.nodes || []),
                    ...(dataCopy.sitemap?.products?.nodes || []),
                ],
                allFilters: { ...dataCopy.allWcFilters },
                settings: { ...dataCopy.wcPriceSettings.wcSettings },
            }
            : undefined, archivePage: dataCopy.archivePage, seo: dataCopy.settingsWp.seoSettings, searchSlug: dataCopy.siteMeta.siteMetadata.hasSearch
            ? dataCopy.searchSlug.slug
            : undefined, footerTemplate: dataCopy.footerTemplate },
        React.createElement(Layout, { infos: infos, seo: seo, customBreadcrumbs: dataCopy.siteMeta.siteMetadata.customBreadcrumbs }, children)));
};
export default ContextLayout;
